import { ProgressResponseSchema, type ProgressResponse } from '@devlearn/shared';
import { api } from '@/lib/apiClient';

export const progressApi = {
  get: (trackSlug: string) =>
    api<ProgressResponse>(`/progress/${trackSlug}`, { schema: ProgressResponseSchema }),
};
